import {NDVSClient} from "../../client/NDVSClient";
import {
    EXPORT_TO_CSV_HEADER,
    PRINT_DRIVER_PACKAGE_SUMMARY_ERROR,
    PRINT_DRIVER_PACKAGE_SUMMARY_SUCCESS, UNASSIGNED_WEB_REJECTS_HEADING
} from "../constants/DriverPackageSummaryConstants";


export function printDriverPackageSummary(dispatcher) {
    NDVSClient.printDriverPackageSummary({
    }).then(({valid, data}) => {
        if (valid) {

            const printDriverPackageSummaryData = [];
            printDriverPackageSummaryData.push([UNASSIGNED_WEB_REJECTS_HEADING])
            data.unassignedRejectedTrackingIdList.forEach(
                printDriverPackageItem=>{
                    printDriverPackageSummaryData.push([printDriverPackageItem.unassignedRejectedPackageId])
                }
            )
            printDriverPackageSummaryData.push(EXPORT_TO_CSV_HEADER)

            const driverToAssignedButRejectedMapping = {}
            const driverToAssignedNeitherDepartedNorRejectedMapping = {}
            data.driverAssignedButRejectedTrackingIdList.forEach(
                printDriverPackageItem=>{
                    var driverName = printDriverPackageItem.driverName;
                    initializeDriverAssignedPackagesMapping(driverName, driverToAssignedButRejectedMapping, driverToAssignedNeitherDepartedNorRejectedMapping)
                    driverToAssignedButRejectedMapping[driverName].push(printDriverPackageItem.rejectedPackageId)
                }
            )

            data.driverAssignedNotDepartedTrackingIdList.forEach(
                printDriverPackageItem=>{
                    var driverName = printDriverPackageItem.driverName;
                    initializeDriverAssignedPackagesMapping(driverName, driverToAssignedButRejectedMapping, driverToAssignedNeitherDepartedNorRejectedMapping)
                    driverToAssignedNeitherDepartedNorRejectedMapping[driverName]
                        .push(printDriverPackageItem.assignedNotDepartedPackageId)
                }
            )

            Object.keys(driverToAssignedNeitherDepartedNorRejectedMapping).forEach(driverNameKey=> {
                    let maxTrackingIds = Math.max(driverToAssignedNeitherDepartedNorRejectedMapping[driverNameKey].length,
                        driverToAssignedButRejectedMapping[driverNameKey].length);
                    for(let packageIndex = 0; packageIndex < maxTrackingIds ; packageIndex++) {
                        printDriverPackageSummaryData.push(getPrintDrivePackageSummaryRow(driverNameKey,
                            driverToAssignedNeitherDepartedNorRejectedMapping,
                            driverToAssignedButRejectedMapping,
                            packageIndex));
                    }
                }
            )

            dispatcher({
                type: PRINT_DRIVER_PACKAGE_SUMMARY_SUCCESS,
                data: printDriverPackageSummaryData
            })
        }
        else {
            dispatcher({
                type: PRINT_DRIVER_PACKAGE_SUMMARY_ERROR
            })
        }
    });
}

function initializeDriverAssignedPackagesMapping(driverName, driverToAssignedButRejectedMapping,
    driverToAssignedNeitherDepartedNorRejectedMapping) {
    if (!(driverName in driverToAssignedNeitherDepartedNorRejectedMapping)) {
        driverToAssignedNeitherDepartedNorRejectedMapping[driverName]=[]
    }
    if (!(driverName in driverToAssignedButRejectedMapping)) {
        driverToAssignedButRejectedMapping[driverName]=[]
    }
}

function getPrintDrivePackageSummaryRow(driverNameKey, driverToAssignedNeitherDepartedNorRejectedMapping,
                                        driverToAssignedButRejectedMapping, packageIndex) {
    let printDriverPackageSummaryRow = [];
    printDriverPackageSummaryRow.push(driverNameKey);
    if (packageIndex < driverToAssignedNeitherDepartedNorRejectedMapping[driverNameKey].length) {
        printDriverPackageSummaryRow
            .push(driverToAssignedNeitherDepartedNorRejectedMapping[driverNameKey][packageIndex])
    } else {
        printDriverPackageSummaryRow
            .push("") // This is required since, we are passing this data to csv link directly and
         // this represent a single column,
        // so if the value is not present in that column we need to have empty string
    }
    if (packageIndex < driverToAssignedButRejectedMapping[driverNameKey].length) {
        printDriverPackageSummaryRow
            .push(driverToAssignedButRejectedMapping[driverNameKey][packageIndex])
    } else {
        printDriverPackageSummaryRow
            .push("") // This is required since, we are passing this data to csv link directly and
        // this represent a single column,
        // so if the value is not present in that column we need to have empty string
    }
    return printDriverPackageSummaryRow;
}



// WEBPACK FOOTER //
// ./src/components/driverPackageSummary/network/PrintDriverPackageSummaryNetwork.js